import React, { useState, useEffect, useContext } from "react";
import URLstateContext from "../../../provider/CommonContext";
import LinearProgress from "@mui/material/LinearProgress";
import { format, parseISO } from "date-fns";
import {
  GetPostMethodData,
  DecryptAESdata,
} from "../../../provider/ServiceProvider";
import MaturityProfile from "../PortfolioDebt/MaturityProfile/MaturityProfile";
import PortfolioClassification from "../PortfolioDebt/PortfolioClassification/PortfolioClassification";
import pieChart1 from "../../../images/pie-chart-1.png";
import pieChart2 from "../../../images/pie-chart-2.png";
import animation from "../../../images/jm-animation.gif";

function PortfolioDebt(props) {
  const [data, setData] = useState([]);
  const [dataAll, setDataAll] = useState([]);
  const [dataInd, setDataInd] = useState([]);
  const { BaseURL } = useContext(URLstateContext);
  const [loadingshow, setloadingshow] = useState(false);
  let getSchemeCode = props.SchemeCode;

  const plan =
    props.SchemePlans && props.SchemePlans.trim() !== ""
      ? props.SchemePlans
      : "Direct";

  useEffect(() => {
    setloadingshow(true);
    GetPostMethodData(BaseURL + "GetTop10Holdings", {
      IVSchemeCode: getSchemeCode,
    }).then((data) => {
      setloadingshow(false);
      if (data.data != null && data.data.length > 0) {
        setData(DecryptAESdata(data.data));
        setloadingshow(false);
      }
    });
    GetPostMethodData(BaseURL + "GetFundIndicators", {
      IVSchemeCode: getSchemeCode,
      IVSchemePlan: plan,
    }).then((data) => {
      setloadingshow(false);
      if (data.data != null && data.data.length > 0) {
        setDataInd(DecryptAESdata(data.data));
        setloadingshow(false);
      }
    });
    GetPostMethodData(BaseURL + "GetFundAllocation", {
      IVSchemeCode: getSchemeCode,
    }).then((data) => {
      setloadingshow(false);
      if (data.data != null && data.data.length > 0) {
        setDataAll(DecryptAESdata(data.data));
        setloadingshow(false);
      }
    });
  }, [BaseURL, plan]);

  const chunkSize = 5;
  const chunks = [];
  for (let i = 0; i < data.length; i += chunkSize) {
    chunks.push(data.slice(i, i + chunkSize));
  }
  function getDistinctValuesAsDict(list, key) {
    const distinctValuesSet = new Set(list.map((dict) => dict[key]));
    return Array.from(distinctValuesSet).map((value) => ({ [key]: value }));
  }

  return (
    <>
      <section className="product_portfolio-sc" id="portfolio">
        <div className="flex-asondate">
          <div className="section-heading">Portfolio</div>
          {data &&
            getDistinctValuesAsDict(data, "AsonDate").map(
              ({ AsonDate, index }) => (
                <p key={index} className="text-left DateAson">
                  <span>As on - </span>
                  {AsonDate != null
                    ? format(parseISO(AsonDate), "do MMM, yyyy")
                    : ""}
                </p>
              ),
            )}
        </div>
        {dataAll?.FundCode !== "AA" &&
          dataAll &&
          dataAll.map(({ CashHolding, EquityHolding }, index) => (
            <>
              <p>
                <span>Current Allocation </span>
              </p>
              <ul className="tab-links">
                <li className="active">
                  <img src={pieChart1} alt="pieChart1" />
                  Equity {EquityHolding} %
                </li>
                <li>
                  <img src={pieChart2} alt="pieChart2" />
                  Debt/Cash {CashHolding} %
                </li>
              </ul>

              <LinearProgress variant="determinate" value={EquityHolding} />
            </>
          ))}
        <div className="gradiant-head-flex">
          <MaturityProfile getSchemeCode={getSchemeCode} />
          <PortfolioClassification getSchemeCode={getSchemeCode} />
        </div>
        {/* <div className="gradiant-head-flex">
                    <div className="gradiant-head-box">
                        <div className="gradiant-head-container">
                            <h3 className="gradiant-head left">Holdings</h3>
                        </div>
                        <div className="gradiant-content">
                            <div className="padding-box-inner">
                                <div className="portfolioHold">
                                    {/* {(chunks.length === 0) ? <h6 className="errorMsg">No Data Found !!!</h6> : ''} 
                                    {loadingshow ? (
                                        <div className="textcentervertex HomeLoader">
                                            <img src={animation} alt="Loading" />
                                            <div className="model_popup">Please Wait...</div>
                                        </div>
                                    ) : (
                                        <div>
                                            {data.length === 0 ? (
                                                <h5 className="errormsgComNew">No Data Available</h5>
                                            ) : (
                                                <>
                                                    {chunks.map((chunk, index) => (
                                                        <div key={index} className="top10Holdings">
                                                            {chunk.map((item, itemIndex) => (
                                                                <>
                                                                    <div class="d-flex justify-content-between mb-1">
                                                                        <p class="holding-progress-text pr-sm-4">{item.IssuerLongName}</p>
                                                                        <p class="holding-progress-text percentHolding">{item.PercentToAss}%</p>
                                                                    </div>
                                                                    <LinearProgress variant="determinate" value={item.PercentToAss} />
                                                                    <br></br>
                                                                </>
                                                            ))}
                                                        </div>
                                                    ))}
                                                </>
                                            )}
                                        </div>
                                    )}
                                </div>
                                {/* {loadingshow ? <div className="textcentervertex">
                                    <img src={animation} alt="Loading" />
                                    <div className="model_popup">Please Wait...</div>
                                </div> : ""
                                } 
                            </div>
                        </div>
                    </div>
                </div> */}
        <div className="gradiant-head-flex">
          <div className="gradiant-head-box">
            <div className="gradiant-head-container">
              <h3 className="gradiant-head left">Indicators</h3>
            </div>
            <div className="gradiant-content">
              <div className="fund-flex">
                {dataInd && dataInd.length > 0 ? (
                  Array.isArray(dataInd) &&
                  dataInd.map(
                    ({
                      StdDev,
                      Beta,
                      Sharpe,
                      AvgMaturity,
                      Duration,
                      ModifiedDuration,
                      YTM,
                      PortfolioTurnoverRatio,
                      FundCode,
                    }) => (
                      <div className="fund-flex-indicator">
                        {PortfolioTurnoverRatio != null ? (
                          <ul>
                            <div className="sub-head portt">
                              <p className="hover-fund">
                                {" "}
                                Portfolio Turnover Ratio
                              </p>
                              <li>{PortfolioTurnoverRatio}</li>
                            </div>
                          </ul>
                        ) : (
                          ""
                        )}
                        {StdDev != null ? (
                          <ul className="sub-head text-wrap">
                            <p className="hover-fund">
                              {" "}
                              Standard Deviation
                              <span className="hover-text-summary">
                                Standard deviation is a statistical measure of
                                the range of an investment’s performance. When a
                                mutual fund has a high standard deviation, its
                                means its range of performance is wide, implying
                                greater volatility
                              </span>
                            </p>

                            <li>{StdDev}</li>
                          </ul>
                        ) : (
                          ""
                        )}
                        {Beta != null ? (
                          <ul className="sub-head text-wrap">
                            <p className="hover-fund tooltip-align">
                              Beta
                              <span className="hover-text-summary">
                                Beta (β) is a measure of the volatility—or
                                systematic risk—of a security or portfolio
                                compared to the market as a whole. Stocks with
                                betas higher than 1.0 can be interpreted as more
                                volatile than the S&P.
                              </span>
                            </p>

                            <li>{Beta}</li>
                          </ul>
                        ) : (
                          ""
                        )}
                        {Sharpe != null ? (
                          <ul className="sub-head text-wrap">
                            <h6 className="hover-fund tooltip-align">
                              Sharpe
                              <span className="hover-text-summary">
                                The Sharpe Ratio, named after its founder, the
                                Nobel Laureate William Sharpe, is a measure of
                                risk-adjusted returns. It is calculated using
                                standard deviation and excess return to
                                determine reward per unit of risk
                              </span>
                            </h6>

                            <li>{Sharpe}</li>
                          </ul>
                        ) : (
                          ""
                        )}
                        {AvgMaturity != null ? (
                          <ul className="sub-head text-wrap">
                            <h6>Average Maturity</h6>
                            <li>
                              {AvgMaturity.toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}{" "}
                              {FundCode === "LF" || FundCode === "ON"
                                ? "Days"
                                : FundCode === "FF" ||
                                    FundCode === "IF" ||
                                    FundCode === "SD" ||
                                    FundCode === "LD"
                                  ? "Years"
                                  : ""}
                            </li>
                          </ul>
                        ) : (
                          ""
                        )}
                        {Duration != null ? (
                          <ul className="sub-head text-wrap">
                            <h6>Duration</h6>
                            <li>
                              {Duration.toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}{" "}
                              {FundCode === "LF" || FundCode === "ON"
                                ? "Days"
                                : FundCode === "FF" ||
                                    FundCode === "IF" ||
                                    FundCode === "SD" ||
                                    FundCode === "LD"
                                  ? "Years"
                                  : ""}
                            </li>
                          </ul>
                        ) : (
                          ""
                        )}
                        {ModifiedDuration != null ? (
                          <ul className="sub-head text-wrap">
                            <h6 className="hover-fund tooltip-align">
                              Modified Duration
                              <span className="hover-text-summary">
                                Modified duration is the price sensitivity and
                                the percentage change in price for a unit change
                                in yield
                              </span>
                            </h6>
                            {/* <h6> Modified Duration</h6> */}
                            <li>
                              {ModifiedDuration.toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}{" "}
                              {FundCode === "LF" || FundCode === "ON"
                                ? "Days"
                                : FundCode === "FF" ||
                                    FundCode === "IF" ||
                                    FundCode === "SD" ||
                                    FundCode === "LD"
                                  ? "Years"
                                  : ""}
                            </li>
                          </ul>
                        ) : (
                          ""
                        )}
                        {YTM != null ? (
                          <ul className="sub-head text-wrap">
                            <h6 className="hover-fund tooltip-align">
                              YTM
                              <span className="hover-text-summary">
                                The Yield to Maturity or the YTM is the rate of
                                return anticipated on a bond if held until
                                maturity. YTM is expressed as an annual rate.
                                The YTM factors in the bond’s current market
                                price, par value, coupon interest rate and time
                                to maturity
                              </span>
                            </h6>
                            {/* <h6> YTM</h6> */}
                            <li>
                              {YTM.toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                              %
                            </li>
                          </ul>
                        ) : (
                          ""
                        )}
                      </div>
                    ),
                  )
                ) : (
                  <h6 className="errorMsg">No Data Found !!!</h6>
                )}
                {loadingshow ? (
                  <div className="textcentervertex">
                    <img src={animation} alt="Loading" />
                    <div className="model_popup">Please Wait...</div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default PortfolioDebt;
